const hideChromePicker = (organization?: string): boolean => {
  if (!organization) return false;

  return ["Comcast", "RTX", "Synopsys", "Synopsys Private Workspace", "Target"].includes(organization);
};

export default hideChromePicker;
